module.exports = __webpack_public_path__ + "static/media/gmr_air_default.36a469fe.svg";